import { render, staticRenderFns } from "./ActivityForm.vue?vue&type=template&id=0acba4f1&scoped=true"
import script from "./ActivityForm.vue?vue&type=script&lang=js"
export * from "./ActivityForm.vue?vue&type=script&lang=js"
import style0 from "./ActivityForm.vue?vue&type=style&index=0&id=0acba4f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acba4f1",
  null
  
)

export default component.exports